import React from 'react';
import { 
  CheckBadgeIcon, 
  MapPinIcon, 
  PuzzlePieceIcon 
} from '@heroicons/react/24/outline';
import { messages } from '../constants/messages';

const WhyInvest = () => {
  const icons = [
    // DTCP & TG RERA Approved - Shield/Seal Icon
    <CheckBadgeIcon className="w-12 h-12 text-[#EF5D22]" />,
    // Strategic Locations - Map Pin Icon
    <MapPinIcon className="w-12 h-12 text-[#EF5D22]" />,
    // World-class Infrastructure - Tools/Construction Icon
    <PuzzlePieceIcon className="w-12 h-12 text-[#EF5D22]" />
  ];

  return (
    <section className="py-24 px-4 sm:px-10 bg-[#0A1D2D] text-white">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-20">
          <h2 className="text-4xl sm:text-5xl font-extrabold mb-6 tracking-tight">
            {(messages as any).whyInvest.titlePart1} <span className="text-[#EF5D22]">{(messages as any).whyInvest.titlePart2}</span>
          </h2>
          <p className="text-gray-400 text-lg sm:text-xl font-medium max-w-2xl mx-auto">
            {(messages as any).whyInvest.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12 lg:gap-16">
          {(messages as any).whyInvest.items.map((item: any, idx: number) => (
            <div key={idx} className="flex flex-col items-center text-center group">
              <div className="mb-8 p-4 rounded-2xl bg-white/5 group-hover:bg-[#EF5D22]/10 transition-colors duration-300">
                {icons[idx]}
              </div>
              <h3 className="text-2xl font-bold mb-4 tracking-tight">{item.title}</h3>
              <p className="text-gray-400 text-lg leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyInvest;
